export default __webpack_public_path__ + "static/media/tm.61cb664f.svg";